// extracted by mini-css-extract-plugin
export var card = "QuickInfo-module--card--51631";
export var icon = "QuickInfo-module--icon--1e135";
export var iconWrapper = "QuickInfo-module--icon-wrapper--13d8a";